import { css } from '@emotion/react'
import styled from '@emotion/styled'

import Link from './Link'
import Button, { primaryButtonCss } from './Button'
import Cancel from '../icons/Outline/Icon/Outline/Cancel.svg'
import Check from '../icons/Outline/Icon/Outline/Check.svg'
import ChevronRight from '../icons/ChevronRight.svg'

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`
const SuccessIcon = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.green};
    font-size: 50px;
    margin-bottom: ${theme.spacing.x2}px;

    @media screen and (min-width: ${theme.breakpoints.tablet}px) {
      font-size: 69px;
      margin-bottom: ${theme.spacing.x3}px;
    }
  `,
)
const ErrorIcon = styled(SuccessIcon)(
  ({ theme }) => css`
    color: ${theme.colors.error};
  `,
)

const Heading = styled.h3(
  ({ theme }) => css`
    ${theme.text.heading3(theme)}
    margin-bottom: ${theme.spacing.x2}px;

    @media screen and (min-width: ${theme.breakpoints.tablet}px) {
      margin-bottom: ${theme.spacing.x3}px;
    }
  `,
)
const Text = styled.p(
  ({ theme }) => css`
    margin: 0;
    margin-bottom: ${theme.spacing.x2}px;

    @media screen and (min-width: ${theme.breakpoints.tablet}px) {
      margin-bottom: ${theme.spacing.x3}px;
    }
  `,
)
const StyledLink = styled(Link)(
  ({ theme }) => css`
    ${primaryButtonCss(theme)}
  `,
)
const StyledButton = styled(Button)(
  ({ theme }) => css`
    ${primaryButtonCss(theme)}
  `,
)

interface Props {
  buttonText?: string | undefined
  type: 'success' | 'error'
  onClick?: () => void
  text?: string | undefined
  title?: string | undefined
  link?: {
    text?: string
    href: string
    target?: string
  }
}

const FormResult = ({
  buttonText,
  type,
  onClick,
  text,
  title,
  link,
}: Props) => (
  <Container>
    {type === 'success' && (
      <SuccessIcon>
        <Check />
      </SuccessIcon>
    )}
    {type === 'error' && (
      <ErrorIcon>
        <Cancel />
      </ErrorIcon>
    )}
    <Heading>{title}</Heading>
    <Text>{text}</Text>
    {type === 'success' && link && (
      <StyledLink href={link.href} target={link.target}>
        {link.text} <ChevronRight />
      </StyledLink>
    )}
    {type === 'error' && (
      <StyledButton type="button" onClick={onClick}>
        {buttonText} <ChevronRight />
      </StyledButton>
    )}
  </Container>
)

export default FormResult
